import React from "react";
import {
  makeStyles, createStyles, Theme, Grid, TextField, FormControl,
  Button, Typography, CircularProgress, FormHelperText
} from "@material-ui/core";
import { green, } from '@material-ui/core/colors';
import { typeQaContent, typeUpdateForm } from '../../../../api/helpline/qa'
import { DropzoneArea } from "material-ui-dropzone";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      marginTop: theme.spacing(3),
    },
    textfield: {
      width: "100%"
    },
    wrapper: {
      position: 'relative',
    },
    buttonProgress: {
      color: green[500],
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: "2px",
      marginLeft: -12,
    },
    previewChip: {
      marginTop: theme.spacing(1),
      minWidth: "80px",
      maxWidth: "250px",
    },
    attachedArea: {
      marginTop: theme.spacing(1),
      width: "90%",
    },
  }),
);

interface FormProp {
  form: typeUpdateForm,
  loading: boolean,
  submitcount: number | null,
  qaContent: typeQaContent | undefined,
  handleChangeFile: (files: File[]) => Promise<void>,
  handleChangeForm: (event: React.ChangeEvent<{
    value: unknown;
    name: string | undefined;
  }>) => void,
  onSubmit: () => void,
}
const MAX_FILESIZE: number = parseInt(process.env.REACT_APP_MAX_FILESIZE!, 10)

const FormArea: React.FC<FormProp> = (props) => {
  const classes = useStyles()
  const { loading, form, qaContent, handleChangeFile, handleChangeForm, onSubmit, submitcount } = props

  const check = form.answerContents.length === 0 ? true : loading ? true : false


  if (qaContent && qaContent.qaStatusClsCd !== '4') {
    return (<Grid container justify="center">
      <Grid item xs={12}>
        <FormControl className={classes.textfield} margin="dense" variant="outlined" error={check}>
          <TextField id="answerContents" label="応答内容" required multiline variant="outlined" size='small' name="answerContents" onChange={handleChangeForm} value={form.answerContents} error={check} />
          {check && <FormHelperText>必須項目です</FormHelperText>}
          <FormHelperText>複数行入力できます</FormHelperText>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={8}>
        <FormControl variant="outlined" className={classes.attachedArea} >
          <Typography variant="caption">添付ファイル</Typography>
          {submitcount &&
            <DropzoneArea
              showPreviews={true}
              showPreviewsInDropzone={false}
              useChipsForPreview
              filesLimit={1}
              dropzoneText={"ファイルをここにアップロード"}
              previewGridProps={{ container: { spacing: 1, direction: 'row' } }}
              previewChipProps={{ classes: { root: classes.previewChip }, color: 'primary', size: 'small' }}
              previewText=""
              showAlerts={['error']}
              maxFileSize={MAX_FILESIZE}
              getDropRejectMessage={(rejectedFile: File, acceptedFiles: string[], maxFileSize: number) => (`ファイルサイズの上限は${maxFileSize / 1024 / 1024}MBです`)}
              getFileLimitExceedMessage={(fileLimit) => (`アップロード可能ファイル数は${fileLimit}です`)}
              onChange={handleChangeFile}
            />
          }
        </FormControl>
      </Grid>
      <Grid item xs={12} md={4} >
        <Grid container justify="flex-end" alignItems="flex-end">
          <Grid container direction="column" justify="center" alignItems="center">
            <Grid item>
              <div className={classes.wrapper}>
                <Button variant="contained" color="primary" className={classes.button} size="large" disabled={check} onClick={() => onSubmit()}>
                  送信
          </Button>
                {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
              </div>
            </Grid>
            <Grid item>
              {check && !loading && <Typography color='error' variant="caption">未入力の必須項目があります</Typography>}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid >)
  } else {
    return <React.Fragment></React.Fragment>
  }
}

export default FormArea
